import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import { useEffect } from 'react';
import Link from 'next/link';
import numeral from 'numeral';
import {
  Modal,
  Cancel,
  Next,
  FieldsetGroup,
  DepositButton,
  RefreshButton,
  BalanceShimmer,
  FieldsetWrapper,
} from 'features/community/styled';
import If from 'global/ErrorHandlers/If';
import Image from 'global/Image';
import tradingDataStore from 'lib/stores/tradingData';
import { Community, Fee } from '../../../../../@types/community';
import Fieldset from '../Fieldset';
import Info from '../Info';

interface ConfirmProps {
  isRealTrading?: boolean;
  fee: Fee;
  onOk: () => void;
  title: string;
  until: string;
  visible: boolean;
  onCancel: () => void;
  community: Community;
  communityFee: Fee;
  minBalance?: number;
}

function Confirm({
  isRealTrading = false,
  fee,
  onOk,
  title,
  until,
  visible,
  onCancel,
  community,
  communityFee,
  minBalance = 0,
}: ConfirmProps) {
  const {
    getPortfolio,
    portfolio: {
      data: { tradingbalance },
      isLoading,
    },
  } = tradingDataStore();
  const isSufficient = tradingbalance >= 0 && tradingbalance >= minBalance;

  const refetchPortfolio = () => getPortfolio(isRealTrading, true);
  const renderAmount = (amount = 0) =>
    amount >= 0
      ? `Rp${numeral(Math.abs(Math.floor(amount))).format('0,0')}`
      : `-Rp${numeral(Math.abs(Math.floor(amount))).format('0,0')}`;

  useEffect(() => {
    if (isRealTrading) {
      refetchPortfolio();
    }
  }, [isRealTrading]);

  return (
    <Modal
      title={
        <Text
          size="18px"
          align="center"
          // @ts-expect-error
          pb="18px"
          family="bold"
          height="24.3px"
        >
          {title}
        </Text>
      }
      onOk={onOk}
      onCancel={onCancel}
      visible={visible}
      width={500}
      closeIcon={<Image src="/icon/close.svg" width="10px" height="10px" />}
      footer={[
        // @ts-expect-error
        <Flex align="center" justify="space-between" mt="20px">
          <Cancel width="50%" onClick={onCancel}>
            <Text family="bold" size="14px" height="19px">
              Batal
            </Text>
          </Cancel>
          <Next width="50%" onClick={onOk} disabled={!isSufficient}>
            <Text family="bold" color="white" size="14px" height="19px">
              Aktivasi
            </Text>
          </Next>
        </Flex>,
      ]}
    >
      <FieldsetGroup>
        <Fieldset fee={fee} community={community} communityFee={communityFee} />
        <If condition={minBalance > 0}>
          <FieldsetWrapper tight>
            <Flex justify="space-between" align="flex-start">
              <div>
                {/* @ts-expect-error */}
                <Flex justify="flex-start" align="center" mb="4px">
                  <strong>Trading Balance</strong>
                  {isLoading ? (
                    <BalanceShimmer />
                  ) : (
                    // @ts-expect-error
                    <Text
                      as="strong"
                      color={isSufficient ? '#00AB6B' : '#EE4A49'}
                      weight="bold"
                      mx="4px"
                    >
                      {renderAmount(
                        tradingbalance === 0 ? 0 : Number(tradingbalance),
                      )}
                    </Text>
                  )}
                  <If condition={!isSufficient && !isLoading}>
                    <RefreshButton onClick={refetchPortfolio}>
                      <Image src="/icon/ic_refresh.svg" />
                    </RefreshButton>
                  </If>
                </Flex>
                {/* @ts-expect-error */}
                <Flex justify="space-between" align="flex-start" m="0px">
                  <Text
                    as="span"
                    size="12px"
                    height="16px"
                    color="rgba(150, 150, 150, 1)"
                  >
                    Min {renderAmount(minBalance)} untuk bergabung
                  </Text>
                </Flex>
              </div>
              <If condition={!isSufficient}>
                <Link href="/securities/deposit" target="__blank">
                  <DepositButton type="outline-primary">Deposit</DepositButton>
                </Link>
              </If>
            </Flex>
          </FieldsetWrapper>
        </If>
      </FieldsetGroup>
      <Info until={until} />
    </Modal>
  );
}

export default Confirm;
